






import BaseComponent from "@/components/base-component.vue";
import * as resize from "@/subjects/resize";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class UiTableContainer extends BaseComponent {
  @Prop({default: false})
  xsOrSmAsMobile: boolean;

  xsSmScreen: boolean = resize.isXsOrSmSizeScreen();
  xsScreen: boolean = resize.isXsSizeScreen();

  mounted() {
    resize.windowSizeChanged$.subscribe((val) => {
      this.xsSmScreen = resize.isXsOrSmSizeScreen();
      this.xsScreen = resize.isXsSizeScreen();
    });
  }

}
